import "./header.css";
export const Header = () => {
  return (
    <div className="header">
      <h1 className="header-heading">
        <a href="/">Portfolio</a>
      </h1>
      <nav className="header-nav-links">
        {/* <p className="header-my-blog">My Projects</p> */}
        <p className="header-linkedin">
          <a
            href="https://www.linkedin.com/in/ratan95"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
        </p>
      </nav>
    </div>
  );
};
